import { createTheme } from '@mui/material/styles';
import lightTheme from './lightTheme';

const ProposifyTheme = createTheme(lightTheme);

export default ProposifyTheme;
